import React from 'react';

// Official Tinaney mark: indigo→violet rounded tile with a white shield and an
// emerald check (privacy + consent/verified). Matches the PWA app icon / favicon.
const Logo: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => {
  const id = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      role="img"
      aria-label="Tinaney"
    >
      <defs>
        <linearGradient id={`bg-${id}`} x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="0.55" stopColor="#4F46E5" />
          <stop offset="1" stopColor="#4338CA" />
        </linearGradient>
        <linearGradient id={`chk-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6EE7B7" />
          <stop offset="1" stopColor="#10B981" />
        </linearGradient>
        <radialGradient id={`hi-${id}`} cx="50%" cy="26%" r="80%">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.20" />
          <stop offset="0.6" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect x="0" y="0" width="512" height="512" rx="112" fill={`url(#bg-${id})`} />
      <rect x="0" y="0" width="512" height="512" rx="112" fill={`url(#hi-${id})`} />
      <g transform="translate(94,100) scale(13.5)" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" fill="#ffffff" />
        <path d="M9 12.5l2.2 2.2 4.3-4.6" fill="none" stroke={`url(#chk-${id})`} strokeWidth="2.2" />
      </g>
    </svg>
  );
};

export default Logo;
